import Link from "@amzn/meridian/esm/components/link";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { openUrl } from "../utils/zoomSdkUtils";
import { THEME_COLOR } from "../styles/colors";
import { AIMS_WIKI_URL } from "../constants";

/**
 * "Learn more" link shared by the "Not available" views. Opens the AiMS wiki in Zoom.
 */
const LearnMoreLink = ({ url = AIMS_WIKI_URL }) => (
  <Link onClick={() => openUrl(url)} type="secondary">
    <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
      <Text color="primary" type="b200">
        <u>Learn more</u>
      </Text>
    </Theme>
  </Link>
);

export default LearnMoreLink;
